export default "__VITE_ASSET__nXdSDTtS__"